import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import { Spinner, Typography } from '@telus-uds/components-web';
import axios from 'axios';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';

import Filters from '../../components/filters';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../contentful';
import request, { apiHost, config as axiosConfig } from '../utils/request';

import { ContentWrapper, Box, TopbarWrapper } from '../design/css';
import { getPathVariables } from '../misc';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { useLocaleContext } from '../context/LocaleContext';
import EN from '../../EN.json';
import FR from '../../FR.json';
import Table from './Table';
import Pagination from './Pagination';
import {
  orderNotEligibleforMssReason,
  DevicesOnlyEnglish,
  DevicesOnlyFrench,
  AccessoriesOnlyEnglish,
  AccessoriesOnlyFrench,
  reasonForSubmissionFrenchMappings,
  orderIsNotEligibleForMSSFrenchMappings,
  orderIsNotEligibleForMSS,
  orderWasReturned
} from '../utils/constant';
import { getFormattedDate } from '../utils/utils';
import { getOptions, ChannelModel } from '../orders/models';

const connectionKey = 'ORDERS';

const addDevicesAndAccessoriesValues = ordersList => {
  const devicesOnlyOrAccessoriesOnly = [
    DevicesOnlyEnglish,
    DevicesOnlyFrench,
    AccessoriesOnlyEnglish,
    AccessoriesOnlyFrench
  ];
  return ordersList.map(order => {
    if (
      !order.installationTypeWLS &&
      order[orderNotEligibleforMssReason] &&
      order[orderNotEligibleforMssReason].length &&
      devicesOnlyOrAccessoriesOnly.includes(
        order[orderNotEligibleforMssReason][0]
      )
    ) {
      return {
        ...order,
        installationTypeWLS: order[orderNotEligibleforMssReason][0]
      };
    }
    return order;
  });
};

const initialFilterState = {
  startDate: null,
  endDate: null,
  filterCriteria: null,
  channelId: [],
  province: [],
  assignee: [],
  createdBy: [],
  status: [],
  dealership: [],
  reasonForSubmission: null,
  orderNotEligibleforMssReason: [],
  flag: null,
  reasonForOrderReturned: []
};

const ChannelOrdersDashboardWLS = ({ handleHistoryPush }) => {
  let url = '';
  const local = useLocaleContext();
  const {
    WLS: {
      WIRELESS_ORDER_DETAILS: {
        WLSLandingPage: { searchLabel, searchHint }
      }
    },
    srtDashboard: { successActionMessage, deleteAction },
    ORDERS: { wlsFiltersStatusOptions }
  } = local === 'en-US' ? EN : FR;
  const localizedStrings = useLocalizedStringsContext();
  const staticLabels = localizedStrings[connectionKey];
  const {
    srtDashboard: { noOrders }
  } = localizedStrings;
  const locale = getPathVariables(window.location.pathname)[0];
  const config = {
    ...contentfulFormConfig,
    content_type: 'salesRepDashboard',
    locale
  };
  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const { channels, provinces } = userProfile;
  const history = useHistory();
  const { q } = queryString.parse(history.location.search);
  const [filterState, setFilterState] = useState(initialFilterState);
  const [searchString, setSearchString] = useState(q);
  const [filters, setFilters] = useState('');
  const [pageLayout, setPageLayout] = useState();
  const [ordersList, setOrdersList] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [pageLoading, setPageLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(() => {
    const ChannelOrdersPageWLS = localStorage.getItem('ChannelOrdersPageWLS')
      ? localStorage.getItem('ChannelOrdersPageWLS')
      : 1;
    return ChannelOrdersPageWLS;
  });
  const [salesRepNames, setSalesRepNames] = useState(null);
  const [allChannels, setAllChannels] = useState(null);
  const [dealerships, setDealerships] = useState(null);
  const [fieldsToHide, setFieldsToHide] = useState([
    'orderNotEligibleforMssReason',
    'reasonForOrderReturned'
  ]);
  const reasonForSubmissions = staticLabels['reasonForFubmissionList'];
  const orderNotEligibleForMSSReasons =
    staticLabels['OrderNotEligibleForMSSReasonList'];
  const flags = staticLabels['filterByFlagsList'];
  const reasonsForOrderReturned = staticLabels['filterByReturningReasonList'];
  const filterData = {
    salesRepNames,
    channels: getOptions(channels, ChannelModel),
    provinces,
    dealerships,
    reasonForSubmissions: reasonForSubmissions,
    orderNotEligibleForMSSReasons: orderNotEligibleForMSSReasons,
    flags: flags,
    reasonsForOrderReturned: reasonsForOrderReturned
  };

  const updateFilters = (key, value) => {
    setFilterState({ ...filterState, [key]: value });
    const hiddenFields = fieldsToHide;
    if (key === 'reasonForSubmission') {
      hiddenFields.indexOf('orderNotEligibleforMssReason') == -1
        ? hiddenFields.push('orderNotEligibleforMssReason')
        : null;
      value.value === orderIsNotEligibleForMSS
        ? (hiddenFields.splice(
            hiddenFields.indexOf('orderNotEligibleforMssReason'),
            1
          ),
          setFieldsToHide(hiddenFields))
        : setFieldsToHide(hiddenFields);
    }
    if (key === 'flag') {
      hiddenFields.indexOf('reasonForOrderReturned') == -1
        ? hiddenFields.push('reasonForOrderReturned')
        : null;
      value.value === orderWasReturned
        ? (hiddenFields.splice(
            hiddenFields.indexOf('reasonForOrderReturned'),
            1
          ),
          setFieldsToHide(hiddenFields))
        : setFieldsToHide(hiddenFields);
    }
  };

  const getFilterPayload = () => {
    let resonForSubmissionsList = [];
    if (filterState.reasonForSubmission) {
      resonForSubmissionsList.push(filterState.reasonForSubmission.value);
      resonForSubmissionsList.push(
        reasonForSubmissionFrenchMappings[filterState.reasonForSubmission.value]
      );
    }
    let orderNotEligibleforMssReasonList =
      filterState.reasonForSubmission &&
      filterState.reasonForSubmission.value === orderIsNotEligibleForMSS
        ? filterState.orderNotEligibleforMssReason.map(row => row.value)
        : [];
    if (orderNotEligibleforMssReasonList.length > 0) {
      for (const reason of filterState.orderNotEligibleforMssReason) {
        orderNotEligibleforMssReasonList.push(
          orderIsNotEligibleForMSSFrenchMappings[reason.value]
        );
      }
    }
    const payload = {
      ...filterState,
      assignedUserId: filterState.assignee.length && filterState.assignee[0].id,
      createdBy: filterState.createdBy.length
        ? filterState.createdBy[0].value
        : '',
      province: filterState.province.map(row => row.value),
      channelId:
        filterState.channelId.length > 0
          ? filterState.channelId.map(row => row.value)
          : filterData.channels.map(row => row.value),
      dealership: filterState.dealership.map(row => row.value),
      reasonForSubmission: resonForSubmissionsList,
      orderNotEligibleforMssReason: orderNotEligibleforMssReasonList,
      status: filterState.status.map(row => row.value),
      flag: filterState.flag ? filterState.flag.value : null,
      reasonForOrderReturned:
        filterState.flag && filterState.flag.value === orderWasReturned
          ? filterState.reasonForOrderReturned.map(row => row.value)
          : []
    };
    delete payload.assignee;

    if (filterState.startDate)
      payload.startDate = getFormattedDate(filterState.startDate);
    if (filterState.endDate)
      payload.endDate = getFormattedDate(filterState.endDate);
    return payload;
  };
  const applyFilters = () => {
    setPageNumber(1);
    localStorage.setItem('MyOrdersPageWLS', 1);
    filterOrders();
  };
  const filterOrders = (isResetMode = false) => {
    if (isResetMode === true) {
      fetchOrders();
    } else {
      const payload = getFilterPayload();
      setPageLoading(true);
      setFilters(payload);
      // Phase 9 follow-up: Channel Orders tab MUST show every order on the SM's channel(s)
      // regardless of `canSubmitOrders` / `dealershipVisibilityEnabled`. Sending
      // `dashboard=channelOrders` tells the backend to skip the SM-specific [Op.or] scope
      // built in `roleBasedOrderValidation.js` and let the channelId filter alone govern.
      axios
        .post(
          `${apiHost}/orders/filter?typeOfOrder=wls&dashboard=channelOrders&pageNumber=${pageNumber}&pageSize=${_.get(
            pageLayout,
            'ordersPerPage',
            10
          )}`,
          { ...payload },
          { ...axiosConfig() }
        )
        .then(response => {
          setOrdersList(
            addDevicesAndAccessoriesValues(_.get(response, 'data.results', []))
          );
          setTotalOrders(_.get(response, 'data.totalCount', 0));
          setPageLoading(false);
        })
        .catch(() => {});
    }
  };

  const resetFilters = () => {
    setFilters('');
    localStorage.setItem('ChannelOrdersPageWLS', 1); // reset local stored page number to page = 1
    setPageNumber(1); // reset state of page number to page = 1
    setFilterState({
      ...initialFilterState,
      province: [],
      channelId: [],
      assignee: [],
      channelOrgCode: [],
      outletCode: [],
      salesRepName: [],
      status: [],
      dealership: [],
      reasonForSubmission: null,
      orderNotEligibleforMssReason: [],
      flag: null,
      reasonForOrderReturned: []
    });
    setFieldsToHide(['orderNotEligibleforMssReason', 'reasonForOrderReturned']);
    filterOrders(true);
  };
  // API to fetch all WLS orders
  const fetchOrders = async () => {
    // Phase 9 follow-up: Channel Orders tab MUST show every order on the SM's channel(s)
    // regardless of `canSubmitOrders` / `dealershipVisibilityEnabled`. Sending
    // `dashboard=channelOrders` tells the backend to skip the SM-specific [Op.or] scope.
    return axios
      .get(
        `${apiHost}/orders?typeOfOrder=wls&dashboard=channelOrders&pageNumber=${pageNumber}&pageSize=${_.get(
          pageLayout,
          'ordersPerPage',
          10
        )}&${channels
          .map((n, index) => `channelId[${index}]=${n.id}`)
          .join('&')}`,
        axiosConfig()
      )
      .then(response => {
        setOrdersList(
          addDevicesAndAccessoriesValues(_.get(response, 'data.results', []))
        );
        setTotalOrders(_.get(response, 'data.totalCount', 0));
      })
      .catch(() => {});
  };

  const fetchSalesReps = async () => {
    return axios
      .get(`${apiHost}/users/sales-reps`, axiosConfig())
      .then(response => {
        setSalesRepNames(_.get(response, 'data.salesReps', 0));
      })
      .catch(() => {});
  };

  const fetchDealerships = async () => {
    return axios
      .get(`${apiHost}/dealerships`, axiosConfig())
      .then(response => {
        setDealerships(_.get(response, 'data.rows', 0));
      })
      .catch(() => {});
  };

  const fetchChannels = async () => {
    return axios
      .get(`${apiHost}/channels`, axiosConfig())
      .then(response => {
        setAllChannels(
          getOptions(_.get(response, 'data.channels', 0), ChannelModel)
        );
      })
      .catch(() => {});
  };

  useEffect(() => {
    getContentfulData(config).then(async res => {
      setPageLayout(getData(res));
      setPageLoading(true);
      await Promise.all([
        fetchOrders(),
        fetchSalesReps(),
        fetchChannels(),
        fetchDealerships()
      ]);
      setPageLoading(false);
    });
  }, []);

  useEffect(() => {
    setPageLoading(true);
    if (searchString) {
      localStorage.setItem('AllOrdersPageWLS', 1); // reset local stored page number to page = 1
      setPageNumber(1);
      url = `q=${searchString}`;
      fetchOrders();
    } else if (filters) {
      filterOrders();
    } else {
      fetchOrders();
    }
    setPageLoading(false);
    handleHistoryPush(pageNumber);
  }, [pageNumber]);

  return (
    <>
      <div style={{ padding: '0 6rem' }}>
        <Filters
          updateFilters={(key, value) => updateFilters(key, value)}
          filterState={filterState}
          onApplyFilters={applyFilters}
          onResetFilters={resetFilters}
          data={filterData}
          staticLabels={{ ...staticLabels, wlsFiltersStatusOptions }}
          fieldsToHide={fieldsToHide}
          isWlsFilter={true}
        />
      </div>
      <ContentWrapper style={{ padding: '0 4rem' }}>
        {pageLoading && <Spinner show label="Loading Orders..." />}
        {!pageLoading && ordersList.length === 0 ? (
          <div style={{ textAlign: 'center' }}><Typography block>{noOrders}</Typography></div>
        ) : (
          <>
            <Box
              style={{
                margin: '2rem',
                border: '1px solid #e3e3e3'
              }}
            >
              <TopbarWrapper style={{ color: '#fff', fontWeight: '900' }}>
                {`${_.get(pageLayout, 'tableTitle', '')} (${totalOrders})`}
              </TopbarWrapper>
              <Table
                pageLayout={pageLayout}
                data={ordersList}
                fetchOrders={fetchOrders}
              />
            </Box>
            <Pagination
              ordersPerPage={_.get(pageLayout, 'ordersPerPage', 10)}
              totalOrders={totalOrders}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
            />
          </>
        )}
      </ContentWrapper>
    </>
  );
};

export default ChannelOrdersDashboardWLS;
